import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SettingField } from "@/components/settings/setting-field";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import type { SaveField } from "../../../hooks/use-auto-save-field";
import { OnlineBookingConfig } from "../hooks/use-online-booking-config";

export function ShowServiceDurationToggle({
  saveField,
  saving,
}: {
  saveField: SaveField<OnlineBookingConfig>;
  saving: boolean;
}) {
  const { control } = useFormContext<OnlineBookingConfig>();
  const { t } = useTranslation("settings");

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="showServiceDuration"
        render={({ field }) => (
          <FormItem>
            <SettingField
              label={t("onlineBooking.fields.showServiceDuration.label")}
              helpText={t("onlineBooking.fields.showServiceDuration.helpText")}
              helpDetails={{
                title: t("onlineBooking.fields.showServiceDuration.helpDetails.title"),
                benefits: t("onlineBooking.fields.showServiceDuration.helpDetails.benefits", {
                  returnObjects: true,
                }) as string[],
              }}
            >
              <FormControl>
                <Switch
                  checked={field.value}
                  disabled={saving}
                  onCheckedChange={(value) => {
                    void saveField("showServiceDuration", value);
                  }}
                />
              </FormControl>
            </SettingField>
          </FormItem>
        )}
      />
    </div>
  );
}
